import React from 'react';
import { Icon } from '@iconify/react';

const PurchaseOrderDataTable = ({ purchaseOrders, onEdit, onDelete }) => {
    return (
        <table className="table bordered-table mb-3 rounded-0 w-100">
            <thead>
                <tr>
                    <th className="rounded-0">Number</th>
                    <th>Supplier</th>
                    <th>Order Date</th>
                    <th>Status</th>
                    <th>Total</th>
                    <th className="rounded-0">Actions</th>
                </tr>
            </thead>
            <tbody>
                {purchaseOrders.map((row, idx) => {
                    const statusColour = row.status?.colours?.bootstrapName || 'secondary';
                    return (
                        <tr key={`${row.id}-${idx}`}>
                            <td>{row.poNumber}</td>
                            <td>{row.supplier?.name || ''}</td>
                            <td>{row.orderDate ? row.orderDate.slice(0, 10) : ''}</td>
                            <td>
                                {row.status && (
                                    <span className={`bg-${statusColour}-focus text-${statusColour}-main px-16 py-2 rounded-pill fw-medium text-sm`}>
                                        {row.status.status}
                                    </span>
                                )}
                            </td>
                            <td>{row.totalAmount}</td>
                            <td>
                                <button className="edit-btn w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center mx-6" onClick={() => onEdit(row)}>
                                    <Icon icon="ic:baseline-edit" />
                                </button>
                                <button className="delete-btn w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center" onClick={() => onDelete(row.id)}>
                                    <Icon icon="ic:baseline-delete-outline" />
                                </button>
                            </td>
                        </tr>
                    );
                })}
                {purchaseOrders.length === 0 && (
                    <tr>
                        <td colSpan={6} className="text-center py-2">
                            No Purchase Orders found
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default PurchaseOrderDataTable;
